import TimeSlotsModal from './TimeSlotsModal'

export default TimeSlotsModal
